import { useMemo } from "react";

export const useFAQSchema = ({
  sectionTitle,
  faqs,
}: {
  sectionTitle: string;
  faqs: Array<{ question: string; answer: any }>; 
}) => {
  return useMemo(() => {
    if (!sectionTitle || !faqs || faqs.length === 0) return null;

    const faqItems = faqs.map((faq) => {
      let plainTextAnswer = faq.answer?.raw
        ? JSON.parse(faq.answer.raw)?.content?.map((node: any) =>
            node.content?.map((item: any) => item.value).join(" ")
          ).join("\n")
        : "Answer not available.";

      return {
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": plainTextAnswer,
        },
      };
    });

    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqItems,
    };
  }, [sectionTitle, faqs]);
};
